import React, { useState } from 'react';
import { X } from 'lucide-react';
import { GALLERY_IMAGES } from '../data/content';

const Gallery = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div>
      {/* Hero */}
      <section className="bg-gradient-to-b from-gold-soft/40 to-cream py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-5 md:px-8 text-center animate-fade-in-up">
          <span className="text-gold font-medium text-sm tracking-[0.25em] uppercase">Our Space</span>
          <h1 className="font-serif text-5xl md:text-6xl font-bold mt-4 text-neutral-900">
            Our Gallery
          </h1>
          <div className="gold-divider mx-auto mt-6 mb-8" />
          <p className="text-lg text-neutral-600 leading-relaxed max-w-2xl mx-auto">
            Take a look at our beautiful salon, our work, and the relaxing experience we provide
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-16 md:py-20 bg-cream">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
            {GALLERY_IMAGES.map((img, idx) => (
              <button
                key={idx}
                onClick={() => setSelected(img)}
                className="group relative overflow-hidden rounded-2xl shadow-md bg-white aspect-[4/3] btn-transition hover:shadow-xl"
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover group-hover:scale-105 btn-transition"
                  style={{ transition: 'transform 0.6s ease' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 btn-transition" />
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 btn-transition">
                  <span className="text-xs tracking-widest text-gold uppercase font-medium">{img.tag}</span>
                  <h3 className="font-serif text-2xl text-white">{img.alt}</h3>
                </div>
                <span className="absolute top-4 left-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-neutral-800 border border-white">
                  {img.tag}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selected && (
        <div
          onClick={() => setSelected(null)}
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 animate-fade-in"
        >
          <button
            onClick={() => setSelected(null)}
            aria-label="Close"
            className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 btn-transition flex items-center justify-center"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          <img
            src={selected.src}
            alt={selected.alt}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-[90vh] rounded-xl shadow-2xl"
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
